/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoicesMonth } from './InvoicesMonth';
import {
    InvoicesMonthFromJSON,
    InvoicesMonthFromJSONTyped,
    InvoicesMonthToJSON,
    InvoicesMonthToJSONTyped,
} from './InvoicesMonth';

/**
 * 
 * @export
 * @interface InvoicesYear
 */
export interface InvoicesYear {
    /**
     * 
     * @type {number}
     * @memberof InvoicesYear
     */
    year: number;
    /**
     * 
     * @type {Array<InvoicesMonth>}
     * @memberof InvoicesYear
     */
    months: Array<InvoicesMonth>;
    /**
     * 
     * @type {number}
     * @memberof InvoicesYear
     */
    suma: number;
}

/**
 * Check if a given object implements the InvoicesYear interface.
 */
export function instanceOfInvoicesYear(value: object): value is InvoicesYear {
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('months' in value) || value['months'] === undefined) return false;
    if (!('suma' in value) || value['suma'] === undefined) return false;
    return true;
}

export function InvoicesYearFromJSON(json: any): InvoicesYear {
    return InvoicesYearFromJSONTyped(json, false);
}

export function InvoicesYearFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoicesYear {
    if (json == null) {
        return json;
    }
    return {
        
        'year': json['year'],
        'months': ((json['months'] as Array<any>).map(InvoicesMonthFromJSON)),
        'suma': json['suma'],
    };
}

export function InvoicesYearToJSON(json: any): InvoicesYear {
    return InvoicesYearToJSONTyped(json, false);
}

export function InvoicesYearToJSONTyped(value?: InvoicesYear | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'year': value['year'],
        'months': ((value['months'] as Array<any>).map(InvoicesMonthToJSON)),
        'suma': value['suma'],
    };
}

